import { Link, useLocation } from "react-router-dom";

export function FilmmakerBottomNav() {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex items-center justify-around h-16 px-4">
        {/* Home */}
        <Link
          to="/filmmaker"
          className="flex items-center justify-center w-12 h-12 rounded-lg transition-opacity hover:opacity-80"
        >
          <img 
            src="/home-button.svg" 
            alt="Home" 
            className="h-12 w-12"
          />
        </Link>

        {/* Camera - Remix Icon (disabled) */}
        <div className="flex items-center justify-center w-12 h-12 rounded-lg text-gray-400 opacity-50">
          <i className="ri-camera-3-line text-2xl"></i>
        </div>

        {/* Profile - Remix Icon */}
        <Link
          to="/filmmaker/profile"
          className={`flex items-center justify-center w-12 h-12 rounded-lg transition-colors ${
            isActive('/filmmaker/profile')
              ? 'bg-orange-500 text-white'
              : 'text-gray-600'
          }`}
        >
          <i className="ri-user-3-line text-2xl"></i>
        </Link>
      </div>
    </nav>
  );
}

